import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useMyCafeteriaMenu } from "my-cafeteria/hooks";

interface MyCafeteriaMenuSelectProps {
  id?: string;
  selectedItem: string | number | null;
  onSelectItem: (item: any) => void;
  contractCode: string;
  disabled?: boolean;
  currentStatementItems?: Array<{ menuItem?: { code: string } }>;
  isMobile: boolean;
}

export const MyCafeteriaMenuSelect: React.FC<MyCafeteriaMenuSelectProps> = ({
  id = "001",
  selectedItem,
  onSelectItem,
  contractCode,
  disabled = false,
  currentStatementItems,
  isMobile,
}) => {
  const { t } = useTranslation();
  let label = t("MY_CAFETERIA_BENEFIT");

  const {
    data,
  }: { data?: Array<{ code: string; name: string; isReusable: boolean }> } =
    useMyCafeteriaMenu({ contractCode });

  const handleSelectItem = (e: SelectChangeEvent<string>) => {
    let menuItemCode = e.target.value;
    let result = data?.find(
      (item: { code: string }) => item.code === menuItemCode,
    );
    onSelectItem(result);
  };

  return (
    <FormControl
      variant="outlined"
      disabled={disabled}
      sx={{
        minWidth: isMobile ? "100%" : "290px",
        width: isMobile ? "100%" : "290px",
        backgroundColor: "white",
        mt: 2,
      }}
    >
      <InputLabel id={id} htmlFor={`menu-select-${id}`}>
        {label}
      </InputLabel>
      <Select
        id={`menu-select-${id}`}
        value={selectedItem != null ? String(selectedItem) : ""}
        onChange={handleSelectItem}
        label={label}
        defaultValue=""
        inputProps={{
          id: id,
          style: {
            backgroundColor: "white",
          },
        }}
      >
        <MenuItem value="">-- {t("OC_NOT_SELECTED")} --</MenuItem>
        {data?.map(
          (
            item: { code: string; name: string; isReusable: boolean },
            index,
          ) => {
            let isExist = currentStatementItems?.find(
              (filterItem) => filterItem?.menuItem?.code === item?.code,
            );
            return (
              <MenuItem
                key={index + "-menu-select-item"}
                value={item.code}
                disabled={isExist && !item.isReusable}
              >
                {item.name}
              </MenuItem>
            );
          },
        )}
      </Select>
    </FormControl>
  );
};

export default MyCafeteriaMenuSelect;
